import script from "./app-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./app-footer.vue?vue&type=script&setup=true&lang=js"

import "./app-footer.vue?vue&type=style&index=0&id=2ab363bc&lang=scss"

const __exports__ = script;

export default __exports__